"use client";

import { c as _c } from "react/compiler-runtime";
import GridRow from "../common/grid-row/grid-row";
import GridColumn from "../common/grid-column/grid-column";
import Link, { LinkStyle, LinkType } from "../common/link/link";
import ArrowIcon from "../common/arrow-icon/arrow-icon";
import CurvedUnderline from "@/components/common/curved-underline/curved-underline";
import HomeAds from "./home-ads";
import Image from "@/components/common/image/image";
import imageUrl from "@/sanity/utilities/imageUrl";
import { ToolsGrid } from "@/sanity/sanity.types";
interface HeroProps {
  hero: any;
  heroHeight: number;
}
const HeroComponent = t0 => {
  const $ = _c(45);
  const {
    hero,
    heroHeight
  } = t0;
  let t1;
  if ($[0] !== hero.background) {
    t1 = hero.background?.asset ? `url(${imageUrl(hero.background.asset).url()})` : undefined;
    $[0] = hero.background;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `${heroHeight}px`;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      backgroundImage: t1,
      height: t2,
      minHeight: "631px"
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <HomeAds />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== hero.headline) {
    t5 = <h1>{hero.headline}</h1>;
    $[6] = hero.headline;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== hero.subhead) {
    t6 = <p className="text-xl">{hero.subhead}</p>;
    $[8] = hero.subhead;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== hero.options) {
    t7 = hero.options?.slice(0, 2).map(_temp);
    $[10] = hero.options;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t7) {
    t8 = <div className="grid max-w-fit grid-cols-2 gap-4">{t7}</div>;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== hero.secondaryCta) {
    t9 = hero.secondaryCta?.link && <Link href={hero.secondaryCta.link.href ?? ""} className="group relative"><span>{hero.secondaryCta.link.label}</span><ArrowIcon /><CurvedUnderline /></Link>;
    $[14] = hero.secondaryCta;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t5 || $[17] !== t6 || $[18] !== t8 || $[19] !== t9) {
    t10 = <GridRow><GridColumn lg={7}><div className="flex w-full flex-col gap-6 rounded-2xl bg-[#f2f2f2] px-14 py-10">{t4}{t5}{t6}{t8}{t9}</div></GridColumn></GridRow>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t3) {
    t11 = <div className="m-auto !hidden min-h-[631px] !max-w-[1440px] items-center bg-center bg-no-repeat md:!flex" style={t3}>{t10}</div>;
    $[21] = t10;
    $[22] = t3;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== hero.background || $[25] !== hero.headline) {
    t12 = hero.background?.asset && <Image className="w-full md:!hidden" src={imageUrl(hero.background.asset).height(200).url()} alt={hero.headline ?? ""} width={609} height={200} fetchPriority="high" />;
    $[24] = hero.background;
    $[25] = hero.headline;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <HomeAds />;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== hero.headline) {
    t14 = <h1>{hero.headline}</h1>;
    $[28] = hero.headline;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== hero.subhead) {
    t15 = <h4 className="text-base !font-medium">{hero.subhead}</h4>;
    $[30] = hero.subhead;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== hero.options) {
    t16 = hero.options?.slice(0, 2).map(_temp2);
    $[32] = hero.options;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== hero.secondaryCta) {
    t17 = hero.secondaryCta?.link && <Link href={hero.secondaryCta.link.href ?? ""}><span>{hero.secondaryCta.link.label}</span><ArrowIcon /></Link>;
    $[34] = hero.secondaryCta;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t14 || $[37] !== t15 || $[38] !== t16 || $[39] !== t17) {
    t18 = <GridRow className="grid md:!hidden"><GridColumn><div className="flex flex-col gap-6 py-10">{t13}{t14}{t15}{t16}{t17}</div></GridColumn></GridRow>;
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== t11 || $[42] !== t12 || $[43] !== t18) {
    t19 = <>{t11}{t12}{t18}</>;
    $[41] = t11;
    $[42] = t12;
    $[43] = t18;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  return t19;
};
export default HeroComponent;
function _temp(option, index) {
  return <Link key={index} href={option.cta.link.href ?? ""} linkType={LinkType.BUTTON} linkStyle={index > 0 ? LinkStyle.SECONDARY : LinkStyle.PRIMARY} className="!w-full border-2 border-solid border-[#00698F]">{option.cta.link.label}</Link>;
}
function _temp2(option_0, index_0) {
  return <Link key={index_0} href={option_0.cta.link.href ?? ""} linkType={LinkType.BUTTON} linkStyle={index_0 > 0 ? LinkStyle.SECONDARY : LinkStyle.PRIMARY} className="!w-full border-2 border-solid border-[#00698F]">{option_0.cta.link.label}</Link>;
}